// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background: aliceblue;
  width: 500px;
  max-width: 90%;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  margin-top: 50px;
  max-height: 95vh; /* Prevents overflow on small screens */
  overflow-y: auto; /* Enables scrolling if needed */
}

/* Close button adjustments */
.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  border: none;
  background: none;
  cursor: pointer;
}

/* Responsive styles for small screens */
@media (max-width: 768px) {
  .popup-content {
    width: 95%;
    max-height: 85vh;
    max-width: 80vh;
    padding: 15px;
  }

  .close-btn {
    font-size: 20px;
    top: 8px;
    right: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CreateChannelForm/CreateChannel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAE,uCAAuC;EACzD,gBAAgB,EAAE,gCAAgC;AACpD;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,WAAW;EACb;AACF","sourcesContent":[".popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.2);;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.popup-content {\n  background: aliceblue;\n  width: 500px;\n  max-width: 90%;\n  padding: 20px;\n  border-radius: 8px;\n  position: relative;\n  margin-top: 50px;\n  max-height: 95vh; /* Prevents overflow on small screens */\n  overflow-y: auto; /* Enables scrolling if needed */\n}\n\n/* Close button adjustments */\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  font-size: 24px;\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n/* Responsive styles for small screens */\n@media (max-width: 768px) {\n  .popup-content {\n    width: 95%;\n    max-height: 85vh;\n    max-width: 80vh;\n    padding: 15px;\n  }\n\n  .close-btn {\n    font-size: 20px;\n    top: 8px;\n    right: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
